// /src/components/activities/meditation/constants.js

import {
    SparklesIcon, HeartIcon, HandThumbUpIcon, EyeIcon, CursorArrowRaysIcon, CloudIcon
} from '@heroicons/react/24/solid';

// --- IMPORTAR TODOS LOS ARCHIVOS DE AUDIO DESDE LA CARPETA /meditation/ ---

// Gongs y Campanas
import startBell from '../../../../assets/audios/meditation/gongs/start_bell.mp3';
import classicGong from '../../../../assets/audios/meditation/gongs/classic_gong.mp3';
import tibetanBowl from '../../../../assets/audios/meditation/gongs/tibetan_bowl.mp3';
import deepZenGong from '../../../../assets/audios/meditation/gongs/deep_zen_gong.mp3';
import crystalBell from '../../../../assets/audios/meditation/gongs/crystal_bell.mp3';

// Música de Fondo
import stressRelief from '../../../../assets/audios/meditation/bg/stress_relief_1h.MP3';
import forestSound from '../../../../assets/audios/meditation/bg/forest.mp3';
import oceanSound from '../../../../assets/audios/meditation/bg/ocean.mp3';
import rainSound from '../../../../assets/audios/meditation/bg/rain.mp3';
import pianoSound from '../../../../assets/audios/meditation/bg/ambient_piano.mp3';

// Voces Indicativas
import presenceVoice from '../../../../assets/audios/meditation/voices/presence.mp3';
import gratitudeVoice from '../../../../assets/audios/meditation/voices/gratitude.mp3';
import loveVoice from '../../../../assets/audios/meditation/voices/love.mp3';
import forgivenessVoice from '../../../../assets/audios/meditation/voices/forgiveness.mp3';
import visionVoice from '../../../../assets/audios/meditation/voices/vision.mp3';
import choiceVoice from '../../../../assets/audios/meditation/voices/choice.mp3';
import connectionVoice from '../../../../assets/audios/meditation/voices/connection.mp3';

// Meditaciones Guiadas
import presenceGuided from '../../../../assets/audios/meditation/guided/presence_guided.MP3';
import gratitudeGuided from '../../../../assets/audios/meditation/guided/gratitude_guided.MP3';
import loveGuided from '../../../../assets/audios/meditation/guided/love_guided.MP3';
import forgivenessGuided from '../../../../assets/audios/meditation/guided/forgiveness_guided.MP3';
import visionGuided from '../../../../assets/audios/meditation/guided/vision_guided.MP3';
import choiceGuided from '../../../../assets/audios/meditation/guided/choice_guided.MP3';
import connectionGuided from '../../../../assets/audios/meditation/guided/connection_guided.MP3';

// Audio de Introducción
import introAudioFile from '../../../../assets/audios/meditation/intro_meditation.mp3';


export const PREMIUM_ROLE_ID = 7;

export const INTRO_AUDIO = {
    url: introAudioFile,
};

export const PHASES = [
    { id: 'presence', name: 'Presencia', icon: SparklesIcon, description: "Conecta con el aquí y ahora, siente tu cuerpo y el espacio que ocupas.", voicePrompt: presenceVoice, guidedAudio: presenceGuided },
    { id: 'gratitude', name: 'Gratitud', icon: HeartIcon, description: "Evoca un sentimiento genuino de agradecimiento por lo que tienes en tu vida.", voicePrompt: gratitudeVoice, guidedAudio: gratitudeGuided },
    { id: 'love', name: 'Amor', icon: HeartIcon, description: "Siente el amor incondicional, hacia ti mismo y hacia los demás.", voicePrompt: loveVoice, guidedAudio: loveGuided },
    { id: 'forgiveness', name: 'Perdón', icon: HandThumbUpIcon, description: "Libera cargas perdonando a otros y, más importante, a ti mismo.", voicePrompt: forgivenessVoice, guidedAudio: forgivenessGuided },
    { id: 'vision', name: 'Visión', icon: EyeIcon, description: "Visualiza tu futuro ideal, siéntelo como si ya fuera real.", voicePrompt: visionVoice, guidedAudio: visionGuided },
    { id: 'choice', name: 'Elección', icon: CursorArrowRaysIcon, description: "Elige conscientemente los pensamientos y acciones que te alinean con tu visión.", voicePrompt: choiceVoice, guidedAudio: choiceGuided },
    { id: 'connection', name: 'Conexión', icon: CloudIcon, description: "Siente tu conexión con algo más grande que tú, el universo o la conciencia colectiva.", voicePrompt: connectionVoice, guidedAudio: connectionGuided },
];

export const SOUND_OPTIONS = {
    startEnd: {
        default: { name: "Campana de Inicio", url: startBell }
    },
    gongs: [
        { id: 'gong1', name: "Gong Clásico", url: classicGong, isPremium: false },
        { id: 'gong2', name: "Cuenco Tibetano", url: tibetanBowl, isPremium: true },
        { id: 'gong3', name: "Gong Zen Profundo", url: deepZenGong, isPremium: true },
        { id: 'gong4', name: "Campana de Cristal", url: crystalBell, isPremium: true },
    ],
    background: [
        { id: 'none', name: "Sin Música", url: null, isPremium: false },
        { id: 'stress_relief', name: "Liberador de Estrés", url: stressRelief, isPremium: false },
        { id: 'forest', name: "Bosque Relajante", url: forestSound, isPremium: true },
        { id: 'ocean', name: "Olas del Mar", url: oceanSound, isPremium: true },
        { id: 'rain', name: "Lluvia Suave", url: rainSound, isPremium: true },
        { id: 'piano', name: "Piano Ambiental", url: pianoSound, isPremium: true },
    ]
};